// // import {createStore} from 'redux'
// // import rootReducer from './RootReducer'

// // const store = createStore(rootReducer)
// // export default store

import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit";
import rootReducer from "./RootReducer";

const middleware = [];
if(process.env.NODE_ENV==='development'){
    const {createLogger} = require('redux-logger');
    const logger = createLogger({
        level:'info',
        collapsed:true
    });
    middleware.push(logger);
}
export const store = configureStore({
    reducer:rootReducer,
    //middleware: (getDefaultMiddleware)=>getDefaultMiddleware().concat(...middleware)
});

export type IStateReduced = ReturnType<typeof store.getState>;
export type IAppDispatch = typeof store.dispatch;
